import { useRouter } from 'next/router';
import { useState, useEffect, useContext } from 'react';
import cataloniaCheckinGuest from '../../../custom/catalonia/services/checkinGuest.catalonia.service';
import { BookingContext } from '../../../shared/contexts/Booking.context';
import { LanguageContext } from '../../../shared/contexts/Language.context';
import jsonp from '../utils/jsonp';
const crypto = require('crypto');
import config from '../utils/config';

function useCataloniaForm({ guestFormState, guestFormActions }) {
  const [state, setState] = useState({
    loading: false,
    scriptsLoaded: false,
  });
  const { state: bookingContextState, actions: bookingContextActions } = useContext(BookingContext);

  const { state: languageContextState } = useContext(LanguageContext);
  const router = useRouter();

  const actions = {
    getUserInformation: loginData => {
      console.log('CF', loginData);
      // const command = loginData.command;
      // if (command != 'wp.getWindowConfig') {
      const customParams = JSON.parse(JSON.stringify(bookingContextState.bookingCustomParameters));
      delete customParams['allGuests'];
      customParams[router.query.checkinGuestId] = {
        ...loginData,
        guestPmsIdentifier: loginData.guest_id,
      };

      bookingContextActions.setBookingCustomParameters(customParams);
      // const validMemberId = loginData.member_id && loginData.member_id.length;
      // if (!loginData || !validMemberId) {
      //   actions.startNoMemberCheckin();
      // } else {
      updateState({ loginData });
      // }
      // }
    },
    logoutUser: () => {
      const logoutUri = config.urls(actions.randomHash(), bookingContextState.hotelId)['logout'];
      return new Promise((resolve, reject) => {
        jsonp(logoutUri, () => {
          resolve();
        });
      });
      // if (process.env.NODE_ENV !== 'development') {
      //   return axios
      //     .get(logoutUri)
      //     .then(() => {
      //       return Promise.resolve();
      //     })
      //     .catch(error => {
      //       return Promise.resolve();
      //     });
      // } else {
      //   return new Promise((resolve, reject) => {
      //     jsonp(logoutUri, () => {
      //       resolve();
      //     });
      //   });
      // }
    },
    randomHash: () => {
      var current_date = new Date().valueOf().toString();
      var random = Math.random().toString();
      return crypto
        .createHash('sha1')
        .update(current_date + random)
        .digest('hex');
    },
    loadScripts: () => {
      const scripts = [
        config.urls(actions.randomHash(), bookingContextState.hotelId)['jquery'],
        config.urls(actions.randomHash(), bookingContextState.hotelId)['cataloniaForm'],
      ];
      actions
        .logoutUser()
        .then(() => loadScript(scripts[0]))
        .then(() => loadScript([scripts[1]]))
        .then(() => updateState({ scriptsLoaded: true }))
        .catch(error => console.log(error));

      function loadScript(url) {
        return new Promise((resolve, reject) => {
          var script = document.createElement('script');
          script.onload = resolve;
          script.src = url;
          document.head.appendChild(script);
        });
      }
    },
    setiFrameLoaded: iframeLoaded => {
      updateState({ iframeLoaded });
    },
    startNoMemberCheckin: () => {
      guestFormActions.nextStep();
    },
    requestCheckinGuest: () => {
      if (state.loginData) {
        const { email, member_id: memberId, guest_id: guestId, ocr } = state.loginData;
        cataloniaCheckinGuest(
          bookingContextState.hotelId,
          router.query.checkinGuestId,
          languageContextState.selectedLanguage,
          email,
          guestId,
          memberId
        ).then(response => {
          if (ocr === '1') {
            if (response.guestData.nationality && response.guestData.document_type) {
              bookingContextActions.setGuestFieldValues(router.query.checkinGuestId, {
                nationality: response.guestData.nationality,
                document_type: response.guestData.document_type,
              });
            }
          } else {
            bookingContextActions.setGuestFieldValues(
              router.query.checkinGuestId,
              response.guestData
            );
          }
          const options = {
            force: true,
            ocr: ocr === '0' ? false : true,
            checkboxComLoyalty: response.guestData.checkboxComLoyalty,
            checkboxComCHR: response.guestData.checkboxComCHR,
            checkboxLoyaltyProgram: response.guestData.checkboxLoyaltyProgram,
          };
          guestFormActions.getGuestForm(options);
          guestFormActions.nextStep();
        });
      }
    },
    buildIframeUrl: iframeHash => {
      const checkinGuestId = router.query.checkinGuestId;
      const bookingId = bookingContextState.checkinRequirements?.booking?.bookingIdentifier;
      const position =
        bookingContextState.checkinRequirements?.checkinGuests?.findIndex(
          guest => guest.id === checkinGuestId
        ) + 1;

      const url = config
        .urls(iframeHash, bookingContextState.hotelId)
        ['iframe'].replace('{lang}', languageContextState.selectedLanguage || 'es')
        .replace('{hotelId}', bookingContextState.hotelId)
        .replace('{bookingId}', bookingId)
        .replace('{position}', position);

      return url;
    },
  };

  function updateState(newState) {
    setState(previousState => ({ ...previousState, ...newState }));
  }

  useEffect(() => {
    if (bookingContextState.bookingCustomParameters[router.query.checkinGuestId]) {
      const customParams = bookingContextState.bookingCustomParameters[router.query.checkinGuestId];
      const validMemberId = customParams.member_id && customParams.member_id.length;
      if (validMemberId) actions.getUserInformation(customParams);
      else actions.loadScripts();
    } else if (bookingContextState.bookingCustomParameters['allGuests']) {
      const customParams = JSON.parse(
        JSON.stringify(bookingContextState.bookingCustomParameters['allGuests'])
      );
      const validMemberId = customParams.member_id && customParams.member_id.length;
      if (validMemberId) actions.getUserInformation(customParams);
      else actions.loadScripts();
    } else {
      actions.loadScripts();
    }
    return () => {
      updateState({
        iframeLoaded: false,
        scriptsLoaded: false,
        hotelSlug: bookingContextState.hotelId,
      });
    };
  }, []);

  useEffect(() => {
    if (state.iframeLoaded && !state.loginData) {
      function waitForRespuestaLogado() {
        if (typeof window.respuestaLogado !== 'undefined' && window.respuestaLogado.length) {
          const responseData = JSON.parse(window.respuestaLogado);
          // console.log('CF effect', responseData);
          if (responseData.origin == 'catalonia') {
            actions.getUserInformation(responseData);
          } else {
            setTimeout(waitForRespuestaLogado, 500);
          }
        } else {
          setTimeout(waitForRespuestaLogado, 500);
        }
      }

      waitForRespuestaLogado();
    }
  }, [state.iframeLoaded]);

  useEffect(() => {
    if (state.loginData) {
      actions.requestCheckinGuest();
    }
  }, [state.loginData]);

  return { state, actions };
}

export default useCataloniaForm;
